.parameter-name {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.9rem;
}

.add-parameter-form {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 40rem;
}

.search-input-wrapper {
  flex-shrink: 0;
}

.search-result-wrapper {
  flex-grow: 1;
  overflow-y: auto;
}

.action-buttons {
  flex-shrink: 0;
  padding-top: 1rem
}